<template>
  <div class="hello" v-title data-title="杰宜斯云服务">
    <hhead></hhead>
    <msg></msg>
    <nnav></nnav>
    <div style="position: relative;margin-top: 195px;">
      <foot></foot>
    </div>
  </div>
</template>

<script>
import hhead from "./header/index";
import foot from "./footer/index";
import nnav from "./nav/index";
import msg from "./msg/index";

export default {
  components: { hhead, foot, nnav, msg },
  name: "index",
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/index.vue